/* Imports */
import {
  Component,
  Host,
  Prop,
  h,
} from '@stencil/core';
import { GlobalComponent } from '../classes/GlobalComponent';
import { DataTestId } from './interfaces';

@Component({
  tag: 'g-global-styles',
  styleUrl: 'g-global-styles.scss',
})

/**
 * The g-global-styles component is to help ensure these styles load at the beginning of your CSS cascade.
 * @template DataTestId - The type and structure of the value for the dataTestId prop
 */
export class GGlobalStyles implements GlobalComponent<DataTestId> {
  /**
   * Used to set the data-testid attributes on various parts of this component's rendered DOM
   */
  @Prop() dataTestId?: DataTestId;

  render() {
    const baseClass = 'g__global-styles';

    return (
      <Host data-testid={this.dataTestId?.host || baseClass} />
    );
  }
}

export type GGlobalStylesProps = InstanceType<typeof GGlobalStyles>;
